import styled from "styled-components";
import { StyledSectionForm } from "../../styles/form";

const StyledSectionRegister = styled(StyledSectionForm)`
	& > div {
		justify-content: space-between;
	}
`;
export default StyledSectionRegister;
